<template>
    <v-app>
        <v-container fluid>
            <div>
                <transition name="modal-fade">
                    <div class="modal-backdrop">
                        <section>
                            <v-progress-circular :size="70" :width="8" color="blue" indeterminate></v-progress-circular>
                        </section>
                    </div>
                </transition>
            </div>
        </v-container>
    </v-app>
</template>
<script>
    export default {
        name: "Loader",
        props: {
            showLoader: Boolean,
        },
    };
</script>

<style scoped>
    .modal-backdrop {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99999;
    }
</style>
